import React, { Component } from 'react';
import { Button, Card, Form, Row, Table } from 'antd';
import moment from 'moment';
import YearPicker from '@comm/YearPicker';
import { queryWageStatistic } from '@api/hr/wage';

const FormItem = Form.Item;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageNo: 1,
    };
  }

  componentDidMount() {
    this.loadData(1);
  }

  loadData = pageNo => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    this.setState({
      pageNo,
    });
    queryWageStatistic({
      ...params,
      ...this.props.form.getFieldsValue(),
    }).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  handleSearch = e => {
    e.preventDefault();
    this.loadData();
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" style={{ textAlign: 'right' }} onSubmit={this.handleSearch}>
        <FormItem>
          {getFieldDecorator('year', {
            initialValue: moment.unix(new Date().getTime() / 1000).format('YYYY'),
          })(<YearPicker style={{ width: '200px' }} />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" style={{ marginRight: '-16px' }}>
            查询
          </Button>
        </FormItem>
      </Form>
    );
  };

  columns = () => {
    return [
      {
        title: '单位名称',
        dataIndex: 'crorgFullName',
      },
      {
        title: '1月',
        dataIndex: 'jan_',
      },
      {
        title: '2月',
        dataIndex: 'feb_',
      },
      {
        title: '3月',
        dataIndex: 'mar_',
      },
      {
        title: '4月',
        dataIndex: 'apr_',
      },
      {
        title: '5月',
        dataIndex: 'may_',
      },
      {
        title: '6月',
        dataIndex: 'jun_',
      },
      {
        title: '7月',
        dataIndex: 'jul_',
      },
      {
        title: '8月',
        dataIndex: 'aug_',
      },
      {
        title: '9月',
        dataIndex: 'sep_',
      },
      {
        title: '10月',
        dataIndex: 'oct_',
      },
      {
        title: '11月',
        dataIndex: 'nov_',
      },
      {
        title: '12月',
        dataIndex: 'dec_',
      },
      {
        title: '年终奖',
        dataIndex: 'bonusNetPay',
      },
    ];
  };

  render() {
    const { data, total } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <Row>
            <div className="tableListForm">{this.renderSearchForm()}</div>
          </Row>
        </div>
        <Table
          rowKey="crorgUuid"
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/hr/wage/PageStatic.js